var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, TransformValidateDateTime, TransformValidateModel, } from '@musicaudienceexchange/toccata';
export class LeadSource extends Model {
}
__decorate([
    TransformValidateDateTime()
], LeadSource.prototype, "createdAt", void 0);
__decorate([
    validator.IsString()
], LeadSource.prototype, "source", void 0);
__decorate([
    validator.IsString()
], LeadSource.prototype, "sourceId", void 0);
__decorate([
    validator.IsOptional()
], LeadSource.prototype, "meta", void 0);
/**
 * @path {/artist_groups/<artistId>/fans/<fanId>}
 */
export class Fan extends Model {
}
__decorate([
    validator.IsString()
], Fan.prototype, "name", void 0);
__decorate([
    validator.IsString()
], Fan.prototype, "email", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "city", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "state", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "zip", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "country", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "location", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "geo", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], Fan.prototype, "age", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "gender", void 0);
__decorate([
    TransformValidateDateTime()
], Fan.prototype, "createdAt", void 0);
__decorate([
    TransformValidateDateTime()
], Fan.prototype, "updatedAt", void 0);
__decorate([
    TransformValidateDateTime(),
    validator.IsOptional()
], Fan.prototype, "deletedAt", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "phone", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Fan.prototype, "rawPhone", void 0);
__decorate([
    TransformValidateModel(LeadSource, { each: true }),
    validator.IsOptional()
], Fan.prototype, "sources", void 0);
//# sourceMappingURL=index.js.map